const GRAIN_SVG =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export const Grain = () => (
  <div
    data-testid="film-grain-overlay"
    aria-hidden="true"
    className="pointer-events-none fixed inset-0 z-[90] overflow-hidden"
  >
    <div
      className="animate-grain absolute -inset-[100%] opacity-[0.05]"
      style={{ backgroundImage: GRAIN_SVG, backgroundSize: "256px 256px" }}
    />
  </div>
);
